





































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { AcgnFormContent, AcgnFormTitle } from '@/components/';
import { AcgnAppointDetail } from './components/index';
import { namespace } from 'vuex-class';
import { AcgnPop } from '@acgn/herm/src/ui';
import { DatePicker } from 'element-ui';
import { getDateTimeStamp, setDateTimeStamp } from '@acgn/herm/src/util/time';
import { Link, Image } from 'element-ui';
import event from '@acgn/herm/src/util/event';
import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
} from '@acgn/herm/src/ui';
// import { unitTypes } from '@/constants/type-helper';
const TaskGroupAction = namespace('desk/taskGroup').Action;
const CommGetter = namespace('desk/comm').Getter;
const AuthGetter = namespace('desk/auth').Getter;
const moment = require('moment');
import {
  refreshStep
} from '@/api/comic';
@Component({
  components: {
    AcgnFormContent,
    AcgnFormTitle,
    AcgnTable,
    AcgnPop,
    AcgnAppointDetail,
    [Link.name]: Link,
    [DatePicker.name]: DatePicker,
    [Image.name]: Image
  }
})

/**
 * 任务稿件组件
 */
export default class AcgnTaskAuditing extends Vue {
  @Prop() public data: any; // 传入数据
  @Prop() public refresh: any; // 刷新
  @Prop() public refreshApproList: any; // 刷新审批列表
  @Prop() public editStatasModel: any;
  @Prop() public servicesTime: any;
  private chapter: any = ''; // 章节
  private visible: any = false;
  private visibleTime: any = false;
  private visibleReset: any = false;
  private visiblePrice: any = false;
  private cellNumber: any = 0;
  private price: any = 0;
  private endDate: any = '';
  private appoint: any = false;
  private linkId: any = 0;
  private defaultUserImage: string = 'https://activity-resource.oss-cn-hangzhou.aliyuncs.com/h5_activity_product/icon/user_img.jpeg'; // 默认头像
  private unitType: number = 1;
  // private unitTypes: any = unitTypes;
  @TaskGroupAction private editLinkInfo: any; // 编辑件数截止日期
  @TaskGroupAction private resetLink: any;  // 重置环节
  @CommGetter private attributeData: any; // 公共类型
  @TaskGroupAction private editLinkPrice: any; // 编辑格子价格
  @TaskGroupAction private setLinkStatus: any; // 设置状态
  @AuthGetter private userInfo: any;
  private get unitTypes() {
    return this.attributeData.unit_type;
  }
  private pickerOptions: any = {
    disabledDate(time: any) {
      return time.getTime() + 86400000 <= Date.now(); // 选当前时间之后的时间
    }
  };


  // 编辑件数
  private editCellNumber() {
    this.cellNumber = this.data.cell_number;
    this.visible = true;
  }

  private editCellPrice() {
    this.price = this.data.price;
    this.visiblePrice = true;
  }

  private close() {
    this.visible = false;
    this.visibleTime = false;
    this.visibleReset = false;
    this.visiblePrice = false;
  }

  private setDateTimeStamp(date: any) {
    return setDateTimeStamp(date, 'YYYY-MM-DD HH:mm:ss');
  }

  // 提交件数
  private async submit() {
    if (this.cellNumber < 0) {
      this.$message.warning(`请输入正确的${this.unitTypes[this.unitType - 1].name}数`);
      return;
    }
    const date = this.setDateTimeStamp(this.data.over_submit_time);
    const params = {
      link_id: this.data.id,
      cell_number: this.cellNumber,
      unit_type: this.unitType,
      over_submit_time: getDateTimeStamp(date , 'YYYY-MM-DD HH:mm:ss')
    };
    try {
      await this.editLinkInfo(params);
    } catch (err) {
      this.$message.error(err.message);
      return;
    }
    this.refresh();
    this.$message.success('保存成功');
    this.visible = false;
    this.cellNumber = 0;
  }
  // 修改价格
  private async submitPrice() {
    const params = {
      link_id: this.data.id,
      price: this.price,
    };
    try {
    await this.editLinkPrice(params);
    } catch (err) {
      this.$message.error(err.message);
      return;
    }
    this.refresh();
    this.$message.success('保存成功');
    this.visiblePrice = false;
  }

  // 编辑截止时间
  private editEndTime() {
    this.visibleTime = true;
  }

  // 提交截止时间
  private async submitEndTime() {
    const params = {
      link_id: this.data.id,
      cell_number: this.data.cell_number,
      over_submit_time: getDateTimeStamp(this.endDate , 'YYYY-MM-DD HH:mm:ss')
    };
    await this.editLinkInfo(params);
    this.refresh();
    this.$message.success('保存成功');
    this.visibleTime = false;
  }

  // 重置
  private reset() {
    this.visibleReset = true;
  }

  // 重置确认
  private async submitReset() {
    const params = {
      link_id: this.data.id,
    };
    await this.resetLink(params);
    this.refresh();
    this.$message.success('重置成功');
    this.visibleReset = false;
  }

  // 审批详情
  private getAppro(data: any) {
    this.refreshApproList(data);
  }

  // 指派
  private getAppoint() {
    this.appoint = true;
  }

  private getNoEventClass() {
    return this.data.show_status === 1 ? '' : ' noevent';
  }

  // 审批状态样式
  private getStaClass(status: any) {
    const className = this.getNoEventClass();
    switch (status) {
      case 1:
        return `acgn-succ${className}`;
      case 2:
        return `acgn-ing${className}`;
      case 3:
        return `acgn-refuse${className}`;
      case 4:
        return `acgn-pass${className}`;
      case 5:
        return `acgn-succ${className}`;
    }
  }

  // 打开编辑状态弹框
  private editStatas() {
    const { name, over_approve_status, over_submit_status, id, status } = this.data;
    if (status === 2 || status === 1) {
      return false;
    }
    this.editStatasModel(name, over_approve_status, over_submit_status, id);
  }

  // 图片src
  private getImageListStr(item: any) {
    return `${(window as any).configs.imageDomain + item}`;
  }
  // 图片列表
  private getImageList(item: any) {
    return [`${(window as any).configs.imageDomain + item}`];
  }

  // 附件下载地址
  private getFileList(item: any) {
    const str = item.toString();
    if (str.startsWith('http://') || str.startsWith('https://') ) {
      return str.replace('http://', 'https://');
    }
    return `${(window as any).configs.imageDomain + item}`;
    // return item;
  }

  // 逾期 审批
  private get statusOverdue() {
    return this.attributeData.other_type[1][1].name;
  }

  // 逾期 提交
  private get statusSubmit() {
    return this.attributeData.other_type[2][1].name;
  }

  // 审批状态列表
  private get statusName() {
    return this.attributeData.other_type[0];
  }

  // 审批状态名称
  private getStaName(status: any) {
    return this.statusName[status - 1].name;
  }
  // 审批状态名称
  private async setLinkStatusHanddle() {
    const { show_status, id } = this.data;
    await this.setLinkStatus({
      link_id: id,
      status: show_status ? 0 : 1
    });
    this.refresh();
  }
  // 任务组-重置环节
  private refreshStepHanddle(files: any) {
    refreshStep({
      id: files.instances_id
    }).then((res) => {
      const { status, data } = res;
      if (status === 0 && data === true) {
        this.refresh();
      }
    });
  }

  private isCurrentMonth(data: any) {
    if (this.servicesTime && data.approve_time) {
      const flag = moment(this.servicesTime).diff(moment(data.approve_time || moment()), 'month');
      return !flag;
    } else {
      return true;
    }
  }
}
